import { ApplicationState } from '../store';
import { EnrollmentStep } from './enrollmentModel';

export const getIsLoading = (state: ApplicationState) =>
  state.enrollment.isLoading;
export const getEnrollmentId = (state: ApplicationState) =>
  state.enrollment.enrollmentId;
export const getActiveStep = (state: ApplicationState) =>
  state.enrollment.activeStep;
export const getEnrollmentSteps = (state: ApplicationState) =>
  state.enrollment.enrollmentSteps;
export const getActiveStepIndex = (state: ApplicationState) => {
  const enrollmentSteps: EnrollmentStep[] = getEnrollmentSteps(state);
  const activeStep: EnrollmentStep = getActiveStep(state);
  return enrollmentSteps.findIndex(
    (step: EnrollmentStep) => step === activeStep
  );
};
export const getIsDFINAdmin = (state: ApplicationState) =>
  state.enrollment.isDFINAdmin;
export const getEntityInfo = (state: ApplicationState) =>
  state.enrollment.entityInfo;
export const getAccountAdminOne = (state: ApplicationState) =>
  state.enrollment.accountAdminOne;
export const getAccountAdminTwo = (state: ApplicationState) =>
  state.enrollment.accountAdminTwo;
export const getEnrollmentStepIds = (state: ApplicationState) =>
  state.enrollment.enrollmentStepIds;
export const getEnrollmentType = (state: ApplicationState) =>
  state.enrollment.enrollmentType;
export const getTemplateUploadStatus = (state: ApplicationState) =>
  state.enrollment.templateUploadStatus;
export const getIsEdgarAvailable = (state: ApplicationState) =>
  state.enrollment.isEdgarAvailable;
export const getTemplateUploadError = (state: ApplicationState) =>
  state.enrollment.templateUploadError;
export const getLatestEnrollmentId = (state: ApplicationState) =>
  state.enrollment.latestEnrollmentId;
